import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  collapsed = true;
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }
}



// WEBPACK FOOTER //
// C:/Users/Jeffrey/Documents/web development/ciphersite/src/app/app.component.ts